// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: UJeCFCdk-Ve

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSourceCategoryButton.module.css"; // plasmic-import: UJeCFCdk-Ve/css

import IconsSourcesRss4Icon from "./icons/PlasmicIcon__IconsSourcesRss4"; // plasmic-import: CNdXXANGY2i/icon
import IconsSourcesSavedForLaterIcon from "./icons/PlasmicIcon__IconsSourcesSavedForLater"; // plasmic-import: sGge8vvbDB/icon
import IconsSourcesPodcastIcon from "./icons/PlasmicIcon__IconsSourcesPodcast"; // plasmic-import: jXirLckZi62/icon
import IconsSourcesYoutube3Icon from "./icons/PlasmicIcon__IconsSourcesYoutube3"; // plasmic-import: Ej-P8A15Myq/icon
import XLogoIcon from "./icons/PlasmicIcon__XLogo"; // plasmic-import: DfpY7AN70dzF/icon
import SpotifyLogoIcon from "./icons/PlasmicIcon__SpotifyLogo"; // plasmic-import: 7r3Uzwe2O/icon
import PinterestNewExtractedConvertedsvgIcon from "./icons/PlasmicIcon__PinterestNewExtractedConvertedsvg"; // plasmic-import: uJdOpqiqtk/icon
import InstagramConvertedThicksvgIcon from "./icons/PlasmicIcon__InstagramConvertedThicksvg"; // plasmic-import: H068MZj0A3/icon

createPlasmicElementProxy;

export type PlasmicSourceCategoryButton__VariantMembers = {
  category:
    | "twitter"
    | "youtube"
    | "websites"
    | "savedForLater"
    | "podcasts"
    | "twitterBookmarks"
    | "twitterUserTimelines"
    | "twitterHomeFeed"
    | "twitterMentions"
    | "twitterLikes"
    | "twitterSearches"
    | "twitterLists"
    | "youtubeChannels"
    | "youtubePlaylists"
    | "spotify"
    | "spotifyPlaylists"
    | "spotifyMusicians"
    | "spotifyPodcasts"
    | "pinterest"
    | "pinterestUserSavedPins"
    | "pinterestUserCreatedPins"
    | "pinterestBoards"
    | "instagram"
    | "instagramUserPosts"
    | "instagramHashtags"
    | "instagramSearchTerms"
    | "pinterestSearchTerms";
  big: "_default";
};
export type PlasmicSourceCategoryButton__VariantsArgs = {
  category?: SingleChoiceArg<
    | "twitter"
    | "youtube"
    | "websites"
    | "savedForLater"
    | "podcasts"
    | "twitterBookmarks"
    | "twitterUserTimelines"
    | "twitterHomeFeed"
    | "twitterMentions"
    | "twitterLikes"
    | "twitterSearches"
    | "twitterLists"
    | "youtubeChannels"
    | "youtubePlaylists"
    | "spotify"
    | "spotifyPlaylists"
    | "spotifyMusicians"
    | "spotifyPodcasts"
    | "pinterest"
    | "pinterestUserSavedPins"
    | "pinterestUserCreatedPins"
    | "pinterestBoards"
    | "instagram"
    | "instagramUserPosts"
    | "instagramHashtags"
    | "instagramSearchTerms"
    | "pinterestSearchTerms"
  >;
  big?: MultiChoiceArg<"_default">;
};
type VariantPropType = keyof PlasmicSourceCategoryButton__VariantsArgs;
export const PlasmicSourceCategoryButton__VariantProps =
  new Array<VariantPropType>("category", "big");

export type PlasmicSourceCategoryButton__ArgsType = {
  manualSizeFactor?: string;
};
type ArgPropType = keyof PlasmicSourceCategoryButton__ArgsType;
export const PlasmicSourceCategoryButton__ArgProps = new Array<ArgPropType>(
  "manualSizeFactor"
);

export type PlasmicSourceCategoryButton__OverridesType = {
  root?: p.Flex<"div">;
  button?: p.Flex<"button">;
  svg?: p.Flex<"svg">;
  textContainer?: p.Flex<"div">;
};

export interface DefaultSourceCategoryButtonProps {
  manualSizeFactor?: string;
  category?: SingleChoiceArg<
    | "twitter"
    | "youtube"
    | "websites"
    | "savedForLater"
    | "podcasts"
    | "twitterBookmarks"
    | "twitterUserTimelines"
    | "twitterHomeFeed"
    | "twitterMentions"
    | "twitterLikes"
    | "twitterSearches"
    | "twitterLists"
    | "youtubeChannels"
    | "youtubePlaylists"
    | "spotify"
    | "spotifyPlaylists"
    | "spotifyMusicians"
    | "spotifyPodcasts"
    | "pinterest"
    | "pinterestUserSavedPins"
    | "pinterestUserCreatedPins"
    | "pinterestBoards"
    | "instagram"
    | "instagramUserPosts"
    | "instagramHashtags"
    | "instagramSearchTerms"
    | "pinterestSearchTerms"
  >;
  big?: MultiChoiceArg<"_default">;
  className?: string;
}

const $$ = {};

function PlasmicSourceCategoryButton__RenderFunc(props: {
  variants: PlasmicSourceCategoryButton__VariantsArgs;
  args: PlasmicSourceCategoryButton__ArgsType;
  overrides: PlasmicSourceCategoryButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "category",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.category
      },
      {
        path: "big",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.big
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootbig__default]: hasVariant($state, "big", "_default"),
          [sty.rootcategory_instagramHashtags]: hasVariant(
            $state,
            "category",
            "instagramHashtags"
          ),
          [sty.rootcategory_instagramSearchTerms]: hasVariant(
            $state,
            "category",
            "instagramSearchTerms"
          ),
          [sty.rootcategory_instagramUserPosts]: hasVariant(
            $state,
            "category",
            "instagramUserPosts"
          ),
          [sty.rootcategory_instagram]: hasVariant(
            $state,
            "category",
            "instagram"
          ),
          [sty.rootcategory_pinterestBoards]: hasVariant(
            $state,
            "category",
            "pinterestBoards"
          ),
          [sty.rootcategory_pinterestSearchTerms]: hasVariant(
            $state,
            "category",
            "pinterestSearchTerms"
          ),
          [sty.rootcategory_pinterestUserCreatedPins]: hasVariant(
            $state,
            "category",
            "pinterestUserCreatedPins"
          ),
          [sty.rootcategory_pinterestUserSavedPins]: hasVariant(
            $state,
            "category",
            "pinterestUserSavedPins"
          ),
          [sty.rootcategory_pinterest]: hasVariant(
            $state,
            "category",
            "pinterest"
          ),
          [sty.rootcategory_podcasts]: hasVariant(
            $state,
            "category",
            "podcasts"
          ),
          [sty.rootcategory_savedForLater]: hasVariant(
            $state,
            "category",
            "savedForLater"
          ),
          [sty.rootcategory_spotifyMusicians]: hasVariant(
            $state,
            "category",
            "spotifyMusicians"
          ),
          [sty.rootcategory_spotifyPlaylists]: hasVariant(
            $state,
            "category",
            "spotifyPlaylists"
          ),
          [sty.rootcategory_spotifyPodcasts]: hasVariant(
            $state,
            "category",
            "spotifyPodcasts"
          ),
          [sty.rootcategory_spotify]: hasVariant($state, "category", "spotify"),
          [sty.rootcategory_twitterBookmarks]: hasVariant(
            $state,
            "category",
            "twitterBookmarks"
          ),
          [sty.rootcategory_twitterHomeFeed]: hasVariant(
            $state,
            "category",
            "twitterHomeFeed"
          ),
          [sty.rootcategory_twitterLikes]: hasVariant(
            $state,
            "category",
            "twitterLikes"
          ),
          [sty.rootcategory_twitterLists]: hasVariant(
            $state,
            "category",
            "twitterLists"
          ),
          [sty.rootcategory_twitterMentions]: hasVariant(
            $state,
            "category",
            "twitterMentions"
          ),
          [sty.rootcategory_twitterSearches]: hasVariant(
            $state,
            "category",
            "twitterSearches"
          ),
          [sty.rootcategory_twitterUserTimelines]: hasVariant(
            $state,
            "category",
            "twitterUserTimelines"
          ),
          [sty.rootcategory_twitter]: hasVariant($state, "category", "twitter"),
          [sty.rootcategory_websites]: hasVariant(
            $state,
            "category",
            "websites"
          ),
          [sty.rootcategory_youtubeChannels]: hasVariant(
            $state,
            "category",
            "youtubeChannels"
          ),
          [sty.rootcategory_youtubePlaylists]: hasVariant(
            $state,
            "category",
            "youtubePlaylists"
          ),
          [sty.rootcategory_youtube]: hasVariant($state, "category", "youtube")
        }
      )}
      id={
        hasVariant($state, "category", "pinterestSearchTerms")
          ? "pinterestSearchTerms"
          : hasVariant($state, "category", "instagramSearchTerms")
          ? "instagramHashtags"
          : hasVariant($state, "category", "instagramHashtags")
          ? "instagramHashtags"
          : hasVariant($state, "category", "instagramUserPosts")
          ? "instagramUserPosts"
          : hasVariant($state, "category", "instagram")
          ? "instagram"
          : hasVariant($state, "category", "pinterestBoards")
          ? "pinterestBoards"
          : hasVariant($state, "category", "pinterestUserCreatedPins")
          ? "pinterestUserCreatedPins"
          : hasVariant($state, "category", "pinterestUserSavedPins")
          ? "pinterestUserSavedPins"
          : hasVariant($state, "category", "pinterest")
          ? "pinterest"
          : hasVariant($state, "category", "spotifyPodcasts")
          ? "spotifyPodcasts"
          : hasVariant($state, "category", "spotifyMusicians")
          ? "spotifyMusicians"
          : hasVariant($state, "category", "spotifyPlaylists")
          ? "spotifyPlaylists"
          : hasVariant($state, "category", "spotify")
          ? "spotify"
          : hasVariant($state, "category", "youtubePlaylists")
          ? "youtubePlaylists"
          : hasVariant($state, "category", "youtubeChannels")
          ? "youtubeChannels"
          : hasVariant($state, "category", "twitterLists")
          ? "twitterLists"
          : hasVariant($state, "category", "twitterSearches")
          ? "twitterSearches"
          : hasVariant($state, "category", "twitterLikes")
          ? "twitterLikes"
          : hasVariant($state, "category", "twitterMentions")
          ? "twitterMentions"
          : hasVariant($state, "category", "twitterHomeFeed")
          ? "twitterHomeFeed"
          : hasVariant($state, "category", "twitterUserTimelines")
          ? "twitterUserTimelines"
          : hasVariant($state, "category", "twitterBookmarks")
          ? "twitterBookmarks"
          : hasVariant($state, "category", "podcasts")
          ? "podcasts"
          : hasVariant($state, "category", "savedForLater")
          ? "hubhubSavedForLater"
          : hasVariant($state, "category", "websites")
          ? "websites"
          : hasVariant($state, "category", "youtube")
          ? "youtube"
          : hasVariant($state, "category", "twitter")
          ? "twitter"
          : undefined
      }
    >
      <p.Stack
        as={"button"}
        data-plasmic-name={"button"}
        data-plasmic-override={overrides.button}
        hasGap={true}
        className={classNames(projectcss.all, projectcss.button, sty.button, {
          [sty.buttonbig__default]: hasVariant($state, "big", "_default"),
          [sty.buttoncategory_instagramHashtags]: hasVariant(
            $state,
            "category",
            "instagramHashtags"
          ),
          [sty.buttoncategory_instagramSearchTerms]: hasVariant(
            $state,
            "category",
            "instagramSearchTerms"
          ),
          [sty.buttoncategory_instagramUserPosts]: hasVariant(
            $state,
            "category",
            "instagramUserPosts"
          ),
          [sty.buttoncategory_instagram]: hasVariant(
            $state,
            "category",
            "instagram"
          ),
          [sty.buttoncategory_pinterestBoards]: hasVariant(
            $state,
            "category",
            "pinterestBoards"
          ),
          [sty.buttoncategory_pinterestSearchTerms]: hasVariant(
            $state,
            "category",
            "pinterestSearchTerms"
          ),
          [sty.buttoncategory_pinterestUserCreatedPins]: hasVariant(
            $state,
            "category",
            "pinterestUserCreatedPins"
          ),
          [sty.buttoncategory_pinterestUserSavedPins]: hasVariant(
            $state,
            "category",
            "pinterestUserSavedPins"
          ),
          [sty.buttoncategory_pinterest]: hasVariant(
            $state,
            "category",
            "pinterest"
          ),
          [sty.buttoncategory_podcasts]: hasVariant(
            $state,
            "category",
            "podcasts"
          ),
          [sty.buttoncategory_savedForLater]: hasVariant(
            $state,
            "category",
            "savedForLater"
          ),
          [sty.buttoncategory_spotifyMusicians]: hasVariant(
            $state,
            "category",
            "spotifyMusicians"
          ),
          [sty.buttoncategory_spotifyPlaylists]: hasVariant(
            $state,
            "category",
            "spotifyPlaylists"
          ),
          [sty.buttoncategory_spotifyPodcasts]: hasVariant(
            $state,
            "category",
            "spotifyPodcasts"
          ),
          [sty.buttoncategory_spotify]: hasVariant(
            $state,
            "category",
            "spotify"
          ),
          [sty.buttoncategory_twitterBookmarks]: hasVariant(
            $state,
            "category",
            "twitterBookmarks"
          ),
          [sty.buttoncategory_twitterHomeFeed]: hasVariant(
            $state,
            "category",
            "twitterHomeFeed"
          ),
          [sty.buttoncategory_twitterLikes]: hasVariant(
            $state,
            "category",
            "twitterLikes"
          ),
          [sty.buttoncategory_twitterLists]: hasVariant(
            $state,
            "category",
            "twitterLists"
          ),
          [sty.buttoncategory_twitterMentions]: hasVariant(
            $state,
            "category",
            "twitterMentions"
          ),
          [sty.buttoncategory_twitterSearches]: hasVariant(
            $state,
            "category",
            "twitterSearches"
          ),
          [sty.buttoncategory_twitterUserTimelines]: hasVariant(
            $state,
            "category",
            "twitterUserTimelines"
          ),
          [sty.buttoncategory_twitter]: hasVariant(
            $state,
            "category",
            "twitter"
          ),
          [sty.buttoncategory_websites]: hasVariant(
            $state,
            "category",
            "websites"
          ),
          [sty.buttoncategory_youtubeChannels]: hasVariant(
            $state,
            "category",
            "youtubeChannels"
          ),
          [sty.buttoncategory_youtubePlaylists]: hasVariant(
            $state,
            "category",
            "youtubePlaylists"
          ),
          [sty.buttoncategory_youtube]: hasVariant(
            $state,
            "category",
            "youtube"
          )
        })}
        id={
          hasVariant($state, "category", "spotifyPlaylists")
            ? "spotifyPlaylists"
            : undefined
        }
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__fKqJ, {
            [sty.freeBoxbig__default__fKqJ968A]: hasVariant(
              $state,
              "big",
              "_default"
            ),
            [sty.freeBoxcategory_podcasts__fKqJtlwEj]: hasVariant(
              $state,
              "category",
              "podcasts"
            ),
            [sty.freeBoxcategory_savedForLater__fKqJnj5Zj]: hasVariant(
              $state,
              "category",
              "savedForLater"
            ),
            [sty.freeBoxcategory_twitterBookmarks__fKqJ7Zzrq]: hasVariant(
              $state,
              "category",
              "twitterBookmarks"
            ),
            [sty.freeBoxcategory_twitterHomeFeed__fKqJiudff]: hasVariant(
              $state,
              "category",
              "twitterHomeFeed"
            ),
            [sty.freeBoxcategory_twitterLists__fKqJtCdU3]: hasVariant(
              $state,
              "category",
              "twitterLists"
            ),
            [sty.freeBoxcategory_twitterSearches__fKqJhogXv]: hasVariant(
              $state,
              "category",
              "twitterSearches"
            ),
            [sty.freeBoxcategory_twitterUserTimelines__fKqJiQoEh]: hasVariant(
              $state,
              "category",
              "twitterUserTimelines"
            ),
            [sty.freeBoxcategory_twitter__fKqJGw4N0]: hasVariant(
              $state,
              "category",
              "twitter"
            ),
            [sty.freeBoxcategory_websites__fKqJgXpC4]: hasVariant(
              $state,
              "category",
              "websites"
            ),
            [sty.freeBoxcategory_youtubeChannels__fKqJ6EPe]: hasVariant(
              $state,
              "category",
              "youtubeChannels"
            ),
            [sty.freeBoxcategory_youtubePlaylists__fKqJ2ExUn]: hasVariant(
              $state,
              "category",
              "youtubePlaylists"
            ),
            [sty.freeBoxcategory_youtube__fKqJi1XPf]: hasVariant(
              $state,
              "category",
              "youtube"
            )
          })}
        >
          <p.PlasmicIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            PlasmicIconType={
              hasVariant($state, "category", "pinterestSearchTerms")
                ? PinterestNewExtractedConvertedsvgIcon
                : hasVariant($state, "category", "instagramSearchTerms")
                ? InstagramConvertedThicksvgIcon
                : hasVariant($state, "category", "instagramHashtags")
                ? InstagramConvertedThicksvgIcon
                : hasVariant($state, "category", "instagramUserPosts")
                ? InstagramConvertedThicksvgIcon
                : hasVariant($state, "category", "instagram")
                ? InstagramConvertedThicksvgIcon
                : hasVariant($state, "category", "pinterestBoards")
                ? PinterestNewExtractedConvertedsvgIcon
                : hasVariant($state, "category", "pinterestUserCreatedPins")
                ? PinterestNewExtractedConvertedsvgIcon
                : hasVariant($state, "category", "pinterestUserSavedPins")
                ? PinterestNewExtractedConvertedsvgIcon
                : hasVariant($state, "category", "pinterest")
                ? PinterestNewExtractedConvertedsvgIcon
                : hasVariant($state, "category", "spotifyPodcasts")
                ? SpotifyLogoIcon
                : hasVariant($state, "category", "spotifyMusicians")
                ? SpotifyLogoIcon
                : hasVariant($state, "category", "spotifyPlaylists")
                ? SpotifyLogoIcon
                : hasVariant($state, "category", "spotify")
                ? SpotifyLogoIcon
                : hasVariant($state, "category", "youtubePlaylists")
                ? IconsSourcesYoutube3Icon
                : hasVariant($state, "category", "youtubeChannels")
                ? IconsSourcesYoutube3Icon
                : hasVariant($state, "category", "twitterLists")
                ? XLogoIcon
                : hasVariant($state, "category", "twitterSearches")
                ? XLogoIcon
                : hasVariant($state, "category", "twitterLikes")
                ? XLogoIcon
                : hasVariant($state, "category", "twitterMentions")
                ? XLogoIcon
                : hasVariant($state, "category", "twitterHomeFeed")
                ? XLogoIcon
                : hasVariant($state, "category", "twitterUserTimelines")
                ? XLogoIcon
                : hasVariant($state, "category", "twitterBookmarks")
                ? XLogoIcon
                : hasVariant($state, "category", "podcasts")
                ? IconsSourcesPodcastIcon
                : hasVariant($state, "category", "savedForLater")
                ? IconsSourcesSavedForLaterIcon
                : hasVariant($state, "category", "youtube")
                ? IconsSourcesYoutube3Icon
                : hasVariant($state, "category", "twitter")
                ? XLogoIcon
                : IconsSourcesRss4Icon
            }
            className={classNames(projectcss.all, sty.svg, {
              [sty.svgbig__default]: hasVariant($state, "big", "_default"),
              [sty.svgcategory_instagramHashtags]: hasVariant(
                $state,
                "category",
                "instagramHashtags"
              ),
              [sty.svgcategory_instagramSearchTerms]: hasVariant(
                $state,
                "category",
                "instagramSearchTerms"
              ),
              [sty.svgcategory_instagramUserPosts]: hasVariant(
                $state,
                "category",
                "instagramUserPosts"
              ),
              [sty.svgcategory_instagram]: hasVariant(
                $state,
                "category",
                "instagram"
              ),
              [sty.svgcategory_pinterestBoards]: hasVariant(
                $state,
                "category",
                "pinterestBoards"
              ),
              [sty.svgcategory_pinterestSearchTerms]: hasVariant(
                $state,
                "category",
                "pinterestSearchTerms"
              ),
              [sty.svgcategory_pinterestUserCreatedPins]: hasVariant(
                $state,
                "category",
                "pinterestUserCreatedPins"
              ),
              [sty.svgcategory_pinterestUserSavedPins]: hasVariant(
                $state,
                "category",
                "pinterestUserSavedPins"
              ),
              [sty.svgcategory_pinterest]: hasVariant(
                $state,
                "category",
                "pinterest"
              ),
              [sty.svgcategory_podcasts]: hasVariant(
                $state,
                "category",
                "podcasts"
              ),
              [sty.svgcategory_savedForLater]: hasVariant(
                $state,
                "category",
                "savedForLater"
              ),
              [sty.svgcategory_spotifyMusicians]: hasVariant(
                $state,
                "category",
                "spotifyMusicians"
              ),
              [sty.svgcategory_spotifyPlaylists]: hasVariant(
                $state,
                "category",
                "spotifyPlaylists"
              ),
              [sty.svgcategory_spotifyPodcasts]: hasVariant(
                $state,
                "category",
                "spotifyPodcasts"
              ),
              [sty.svgcategory_spotify]: hasVariant(
                $state,
                "category",
                "spotify"
              ),
              [sty.svgcategory_twitterBookmarks]: hasVariant(
                $state,
                "category",
                "twitterBookmarks"
              ),
              [sty.svgcategory_twitterHomeFeed]: hasVariant(
                $state,
                "category",
                "twitterHomeFeed"
              ),
              [sty.svgcategory_twitterLikes]: hasVariant(
                $state,
                "category",
                "twitterLikes"
              ),
              [sty.svgcategory_twitterLists]: hasVariant(
                $state,
                "category",
                "twitterLists"
              ),
              [sty.svgcategory_twitterMentions]: hasVariant(
                $state,
                "category",
                "twitterMentions"
              ),
              [sty.svgcategory_twitterSearches]: hasVariant(
                $state,
                "category",
                "twitterSearches"
              ),
              [sty.svgcategory_twitterUserTimelines]: hasVariant(
                $state,
                "category",
                "twitterUserTimelines"
              ),
              [sty.svgcategory_twitter]: hasVariant(
                $state,
                "category",
                "twitter"
              ),
              [sty.svgcategory_websites]: hasVariant(
                $state,
                "category",
                "websites"
              ),
              [sty.svgcategory_youtubeChannels]: hasVariant(
                $state,
                "category",
                "youtubeChannels"
              ),
              [sty.svgcategory_youtubePlaylists]: hasVariant(
                $state,
                "category",
                "youtubePlaylists"
              ),
              [sty.svgcategory_youtube]: hasVariant(
                $state,
                "category",
                "youtube"
              )
            })}
            role={"img"}
          />
        </div>
        <div
          data-plasmic-name={"textContainer"}
          data-plasmic-override={overrides.textContainer}
          className={classNames(projectcss.all, sty.textContainer, {
            [sty.textContainerbig__default]: hasVariant(
              $state,
              "big",
              "_default"
            ),
            [sty.textContainercategory_instagramHashtags]: hasVariant(
              $state,
              "category",
              "instagramHashtags"
            ),
            [sty.textContainercategory_instagramSearchTerms]: hasVariant(
              $state,
              "category",
              "instagramSearchTerms"
            ),
            [sty.textContainercategory_instagramUserPosts]: hasVariant(
              $state,
              "category",
              "instagramUserPosts"
            ),
            [sty.textContainercategory_instagram]: hasVariant(
              $state,
              "category",
              "instagram"
            ),
            [sty.textContainercategory_pinterestBoards]: hasVariant(
              $state,
              "category",
              "pinterestBoards"
            ),
            [sty.textContainercategory_pinterestSearchTerms]: hasVariant(
              $state,
              "category",
              "pinterestSearchTerms"
            ),
            [sty.textContainercategory_pinterestUserCreatedPins]: hasVariant(
              $state,
              "category",
              "pinterestUserCreatedPins"
            ),
            [sty.textContainercategory_pinterestUserSavedPins]: hasVariant(
              $state,
              "category",
              "pinterestUserSavedPins"
            ),
            [sty.textContainercategory_podcasts]: hasVariant(
              $state,
              "category",
              "podcasts"
            ),
            [sty.textContainercategory_savedForLater]: hasVariant(
              $state,
              "category",
              "savedForLater"
            ),
            [sty.textContainercategory_spotifyMusicians]: hasVariant(
              $state,
              "category",
              "spotifyMusicians"
            ),
            [sty.textContainercategory_spotifyPlaylists]: hasVariant(
              $state,
              "category",
              "spotifyPlaylists"
            ),
            [sty.textContainercategory_spotifyPodcasts]: hasVariant(
              $state,
              "category",
              "spotifyPodcasts"
            ),
            [sty.textContainercategory_spotify]: hasVariant(
              $state,
              "category",
              "spotify"
            ),
            [sty.textContainercategory_twitterBookmarks]: hasVariant(
              $state,
              "category",
              "twitterBookmarks"
            ),
            [sty.textContainercategory_twitterHomeFeed]: hasVariant(
              $state,
              "category",
              "twitterHomeFeed"
            ),
            [sty.textContainercategory_twitterLikes]: hasVariant(
              $state,
              "category",
              "twitterLikes"
            ),
            [sty.textContainercategory_twitterLists]: hasVariant(
              $state,
              "category",
              "twitterLists"
            ),
            [sty.textContainercategory_twitterMentions]: hasVariant(
              $state,
              "category",
              "twitterMentions"
            ),
            [sty.textContainercategory_twitterSearches]: hasVariant(
              $state,
              "category",
              "twitterSearches"
            ),
            [sty.textContainercategory_twitterUserTimelines]: hasVariant(
              $state,
              "category",
              "twitterUserTimelines"
            ),
            [sty.textContainercategory_twitter]: hasVariant(
              $state,
              "category",
              "twitter"
            ),
            [sty.textContainercategory_websites]: hasVariant(
              $state,
              "category",
              "websites"
            ),
            [sty.textContainercategory_youtubeChannels]: hasVariant(
              $state,
              "category",
              "youtubeChannels"
            ),
            [sty.textContainercategory_youtubePlaylists]: hasVariant(
              $state,
              "category",
              "youtubePlaylists"
            ),
            [sty.textContainercategory_youtube]: hasVariant(
              $state,
              "category",
              "youtube"
            )
          })}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__v3XwF,
              {
                [sty.textbig__default__v3XwF968A]: hasVariant(
                  $state,
                  "big",
                  "_default"
                ),
                [sty.textcategory_instagramHashtags__v3XwFbMefe]: hasVariant(
                  $state,
                  "category",
                  "instagramHashtags"
                ),
                [sty.textcategory_instagramSearchTerms__v3XwFzFgDw]: hasVariant(
                  $state,
                  "category",
                  "instagramSearchTerms"
                ),
                [sty.textcategory_instagramUserPosts__v3XwFzg32]: hasVariant(
                  $state,
                  "category",
                  "instagramUserPosts"
                ),
                [sty.textcategory_instagram__v3XwF7IhWi]: hasVariant(
                  $state,
                  "category",
                  "instagram"
                ),
                [sty.textcategory_pinterestBoards__v3XwFett2O]: hasVariant(
                  $state,
                  "category",
                  "pinterestBoards"
                ),
                [sty.textcategory_pinterestSearchTerms__v3XwFXhWl0]: hasVariant(
                  $state,
                  "category",
                  "pinterestSearchTerms"
                ),
                [sty.textcategory_pinterestUserCreatedPins__v3XwFjFtQy]:
                  hasVariant($state, "category", "pinterestUserCreatedPins"),
                [sty.textcategory_pinterestUserSavedPins__v3XwFnrHj]:
                  hasVariant($state, "category", "pinterestUserSavedPins"),
                [sty.textcategory_pinterest__v3XwFbuxKr]: hasVariant(
                  $state,
                  "category",
                  "pinterest"
                ),
                [sty.textcategory_podcasts__v3XwFtlwEj]: hasVariant(
                  $state,
                  "category",
                  "podcasts"
                ),
                [sty.textcategory_savedForLater__v3XwFnj5Zj]: hasVariant(
                  $state,
                  "category",
                  "savedForLater"
                ),
                [sty.textcategory_spotifyMusicians__v3XwF6Mgpk]: hasVariant(
                  $state,
                  "category",
                  "spotifyMusicians"
                ),
                [sty.textcategory_spotifyPlaylists__v3XwFtXsP]: hasVariant(
                  $state,
                  "category",
                  "spotifyPlaylists"
                ),
                [sty.textcategory_spotifyPodcasts__v3XwFSgQq]: hasVariant(
                  $state,
                  "category",
                  "spotifyPodcasts"
                ),
                [sty.textcategory_spotify__v3XwFPjWiv]: hasVariant(
                  $state,
                  "category",
                  "spotify"
                ),
                [sty.textcategory_twitterBookmarks__v3XwF7Zzrq]: hasVariant(
                  $state,
                  "category",
                  "twitterBookmarks"
                ),
                [sty.textcategory_twitterHomeFeed__v3XwFiudff]: hasVariant(
                  $state,
                  "category",
                  "twitterHomeFeed"
                ),
                [sty.textcategory_twitterLikes__v3XwFw1Tn7]: hasVariant(
                  $state,
                  "category",
                  "twitterLikes"
                ),
                [sty.textcategory_twitterLists__v3XwFtCdU3]: hasVariant(
                  $state,
                  "category",
                  "twitterLists"
                ),
                [sty.textcategory_twitterMentions__v3XwFsUumK]: hasVariant(
                  $state,
                  "category",
                  "twitterMentions"
                ),
                [sty.textcategory_twitterSearches__v3XwFhogXv]: hasVariant(
                  $state,
                  "category",
                  "twitterSearches"
                ),
                [sty.textcategory_twitterUserTimelines__v3XwFiQoEh]: hasVariant(
                  $state,
                  "category",
                  "twitterUserTimelines"
                ),
                [sty.textcategory_twitter__v3XwFGw4N0]: hasVariant(
                  $state,
                  "category",
                  "twitter"
                ),
                [sty.textcategory_websites__v3XwFgXpC4]: hasVariant(
                  $state,
                  "category",
                  "websites"
                ),
                [sty.textcategory_youtubeChannels__v3XwF6EPe]: hasVariant(
                  $state,
                  "category",
                  "youtubeChannels"
                ),
                [sty.textcategory_youtubePlaylists__v3XwF2ExUn]: hasVariant(
                  $state,
                  "category",
                  "youtubePlaylists"
                ),
                [sty.textcategory_youtube__v3XwFi1XPf]: hasVariant(
                  $state,
                  "category",
                  "youtube"
                )
              }
            )}
          >
            {hasVariant($state, "category", "pinterestSearchTerms")
              ? " Search Terms"
              : hasVariant($state, "category", "instagramSearchTerms")
              ? "Search Terms"
              : hasVariant($state, "category", "instagramHashtags")
              ? " Hashtags"
              : hasVariant($state, "category", "instagramUserPosts")
              ? "User Posts"
              : hasVariant($state, "category", "instagram")
              ? "Instagram"
              : hasVariant($state, "category", "pinterestBoards")
              ? "Boards"
              : hasVariant($state, "category", "pinterestUserCreatedPins")
              ? "Created Pins (by User)"
              : hasVariant($state, "category", "pinterestUserSavedPins")
              ? "Saved Pins (by User)"
              : hasVariant($state, "category", "pinterest")
              ? "Pinterest"
              : hasVariant($state, "category", "spotifyPodcasts")
              ? "Spotify Podcasts"
              : hasVariant($state, "category", "spotifyMusicians")
              ? "Spotify Musicians"
              : hasVariant($state, "category", "spotifyPlaylists")
              ? "Spotify Playlists"
              : hasVariant($state, "category", "spotify")
              ? "Spotify"
              : hasVariant($state, "category", "youtubePlaylists")
              ? "Youtube Playlists"
              : hasVariant($state, "category", "youtubeChannels")
              ? "Youtube Channels"
              : hasVariant($state, "category", "twitterLists")
              ? "Lists"
              : hasVariant($state, "category", "twitterSearches")
              ? "Searches"
              : hasVariant($state, "category", "twitterLikes")
              ? "Likes"
              : hasVariant($state, "category", "twitterMentions")
              ? "Mentions"
              : hasVariant($state, "category", "twitterHomeFeed")
              ? " Home Feed"
              : hasVariant($state, "category", "twitterUserTimelines")
              ? "User Timelines"
              : hasVariant($state, "category", "twitterBookmarks")
              ? " Bookmarks"
              : hasVariant($state, "category", "podcasts")
              ? "Podcasts"
              : hasVariant($state, "category", "savedForLater")
              ? "Saved for Later"
              : hasVariant($state, "category", "websites")
              ? "Websites"
              : hasVariant($state, "category", "youtube")
              ? "Youtube"
              : hasVariant($state, "category", "twitter")
              ? "X / Twitter"
              : "Base\nComponent"}
          </div>
        </div>
      </p.Stack>
      {(hasVariant($state, "big", "_default") ? true : false) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__joUd0, {
            [sty.freeBoxbig__default__joUd0968A]: hasVariant(
              $state,
              "big",
              "_default"
            ),
            [sty.freeBoxcategory_twitterBookmarks__joUd07Zzrq]: hasVariant(
              $state,
              "category",
              "twitterBookmarks"
            ),
            [sty.freeBoxcategory_twitterLists__joUd0TCdU3]: hasVariant(
              $state,
              "category",
              "twitterLists"
            ),
            [sty.freeBoxcategory_twitterSearches__joUd0HogXv]: hasVariant(
              $state,
              "category",
              "twitterSearches"
            ),
            [sty.freeBoxcategory_twitterUserTimelines__joUd0IQoEh]: hasVariant(
              $state,
              "category",
              "twitterUserTimelines"
            ),
            [sty.freeBoxcategory_twitter__joUd0Gw4N0]: hasVariant(
              $state,
              "category",
              "twitter"
            )
          })}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__fljUv,
              {
                [sty.textbig__default__fljUv968A]: hasVariant(
                  $state,
                  "big",
                  "_default"
                )
              }
            )}
          >
            {"more info"}
          </div>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "button", "svg", "textContainer"],
  button: ["button", "svg", "textContainer"],
  svg: ["svg"],
  textContainer: ["textContainer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  button: "button";
  svg: "svg";
  textContainer: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSourceCategoryButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSourceCategoryButton__VariantsArgs;
    args?: PlasmicSourceCategoryButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSourceCategoryButton__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSourceCategoryButton__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSourceCategoryButton__ArgProps,
          internalVariantPropNames: PlasmicSourceCategoryButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSourceCategoryButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSourceCategoryButton";
  } else {
    func.displayName = `PlasmicSourceCategoryButton.${nodeName}`;
  }
  return func;
}

export const PlasmicSourceCategoryButton = Object.assign(
  // Top-level PlasmicSourceCategoryButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    button: makeNodeComponent("button"),
    svg: makeNodeComponent("svg"),
    textContainer: makeNodeComponent("textContainer"),

    // Metadata about props expected for PlasmicSourceCategoryButton
    internalVariantProps: PlasmicSourceCategoryButton__VariantProps,
    internalArgProps: PlasmicSourceCategoryButton__ArgProps
  }
);

export default PlasmicSourceCategoryButton;
/* prettier-ignore-end */
